import { wpFetch } from "./wpfetch";
import { API_WP_POSTS_URL } from "./base";
import { CardListItem, ListPageItem } from "./page";

export type PostItem = ListPageItem & {
  categories: { id: number; name: string; slug: string }[];
  tags: { id: number; name: string; slug: string }[];
};

export type CardPostItem = CardListItem & {
  categories: { id: number; name: string; slug: string }[];
  tags: { id: number; name: string; slug: string }[];
};

export const getPostsWithTags = async (
  category?: string,
  tags?: string[],
): Promise<CardPostItem[]> => {
  // console.log("fetching posts with tags:", tags.join(","));
  const posts = await wpFetch(
    `${API_WP_POSTS_URL}?category=${category}&tags=${tags?.join(",")}`,
  );

  return posts.map((post: PostItem) => {
    return {
      id: post.id,
      title: post.title,
      description: post.description,
      link: post.link,
      image: post.image["large"] || null,
      focalPoint: post.focalPoint || { x: 0.5, y: 0.5 },
      categories: post.categories,
      tags: post.tags,
    };
  });
};
